import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';

import './index.scss';

const styles = bemGenerator('forum-topic', ['last-post']);

const Topic = ({ topic }) => (
  // eslint-disable-next-line react/jsx-no-target-blank
  <a className={styles.block} href={topic.uri} target="_blank" rel="noopener">
    <span>{topic.title}</span>
    <span className={styles['last-post']}>{topic.lastPost}</span>
  </a>
);

Topic.propTypes = {
  topic: PropTypes.shape({
    id: PropTypes.number.isRequired,
    uri: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    lastPost: PropTypes.string.isRequired,
  }).isRequired,
};
export default Topic;
